var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jp-common-layout page" }, [
    _c("div", { staticClass: "jp-common-layout-left" }, [
      _c(
        "div",
        { staticClass: "jp-common-title" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 5 } },
            [
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "输入关键字进行过滤", size: "small" },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-button", {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-plus",
                      circle: "",
                    },
                    on: { click: _vm.addTreeNode },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "jp-common-el-tree-scrollbar el-scrollbar" }, [
        _c("div", { staticClass: "el-scrollbar__wrap" }, [
          _c(
            "div",
            { staticClass: "el-scrollbar__view" },
            [
              _c("el-tree", {
                ref: "carKindTree",
                staticClass: "filter-tree",
                attrs: {
                  data: _vm.carKindTreeData,
                  props: {
                    value: "id", // ID字段名
                    label: "name", // 显示名称
                    children: "children", // 子级字段名
                  },
                  "default-expand-all": "",
                  "highlight-current": "",
                  "node-key": "id",
                  "filter-node-method": _vm.filterNode,
                  "expand-on-click-node": false,
                },
                on: { "node-click": _vm.handleNodeClick },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c("span", { staticClass: "custom-tree-node" }, [
                        _c("span", [_vm._v(_vm._s(node.label))]),
                        _c(
                          "span",
                          [
                            _c("el-button", {
                              staticClass: "tree-item-button",
                              attrs: { type: "text", icon: "el-icon-plus" },
                              on: {
                                click: function () {
                                  return _vm.addChildTreeNode(data)
                                },
                              },
                            }),
                            _c("el-button", {
                              staticClass: "tree-item-button",
                              attrs: {
                                type: "text",
                                icon: "el-icon-edit-outline",
                              },
                              on: {
                                click: function () {
                                  return _vm.editTreeNode(data)
                                },
                              },
                            }),
                            _c("el-button", {
                              staticClass: "red tree-item-button",
                              attrs: { type: "text", icon: "el-icon-delete" },
                              on: {
                                click: function () {
                                  return _vm.delTreeNode(data)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "jp-common-layout-center jp-flex-main" },
      [
        _c(
          "el-form",
          {
            ref: "searchForm",
            staticClass: "query-form",
            attrs: { size: "small", inline: true, model: _vm.searchForm },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.refreshList()
              },
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { prop: "kind.id" } },
              [
                _c("SelectTree", {
                  ref: "kind",
                  attrs: {
                    props: {
                      value: "id", // ID字段名
                      label: "name", // 显示名称
                      children: "children", // 子级字段名
                    },
                    size: "small",
                    url: "/test/treetable/carKind/treeData",
                    value: _vm.searchForm.kind.id,
                    clearable: true,
                    accordion: true,
                  },
                  on: {
                    getValue: function (value) {
                      _vm.searchForm.kind.id = value
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-search",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.refreshList()
                      },
                    },
                  },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", icon: "el-icon-refresh-right" },
                    on: {
                      click: function ($event) {
                        return _vm.resetSearch()
                      },
                    },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "bg-white top" },
          [
            _c("vxe-toolbar", {
              attrs: {
                refresh: { query: _vm.refreshList },
                import: "",
                export: "",
                print: "",
                custom: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "buttons",
                  fn: function () {
                    return [
                      _vm.hasPermission("test:treetable:car:add")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-plus",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.add()
                                },
                              },
                            },
                            [_vm._v("新建")]
                          )
                        : _vm._e(),
                      _vm.hasPermission("test:treetable:car:edit")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "warning",
                                size: "small",
                                icon: "el-icon-edit-outline",
                                disabled:
                                  _vm.$refs.carTable &&
                                  _vm.$refs.carTable.getCheckboxRecords()
                                    .length !== 1,
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.edit()
                                },
                              },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.hasPermission("test:treetable:car:del")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                size: "small",
                                icon: "el-icon-delete",
                                disabled:
                                  _vm.$refs.carTable &&
                                  _vm.$refs.carTable.getCheckboxRecords()
                                    .length === 0,
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.del()
                                },
                              },
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "tools",
                  fn: function () {
                    return [
                      _vm.hasPermission("test:treetable:car:import")
                        ? _c("vxe-button", {
                            staticClass: "el-icon-document m-r-12",
                            attrs: {
                              type: "default",
                              title: "下载导入模板",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.downloadTpl()
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c(
              "div",
              { staticStyle: { height: "calc(100% - 80px)" } },
              [
                _c(
                  "vxe-table",
                  {
                    ref: "carTable",
                    attrs: {
                      border: "inner",
                      "auto-resize": "",
                      resizable: "",
                      height: "auto",
                      loading: _vm.loading,
                      size: "small",
                      "show-header-overflow": "",
                      "show-overflow": "",
                      "highlight-hover-row": "",
                      "menu-config": {},
                      "print-config": {},
                      "import-config": {
                        importMethod: _vm.importMethod,
                        types: ["csv", "xls", "xlsx"],
                        remote: true,
                      },
                      "export-config": {
                        remote: true,
                        filename:
                          "车辆数据" +
                          _vm.moment(new Date()).format("YYYY-MM-DD"),
                        sheetName: "车辆数据",
                        exportMethod: _vm.exportMethod,
                        types: ["xlsx"],
                        modes: ["current", "selected", "all"],
                      },
                      "sort-config": { remote: true },
                      data: _vm.dataList,
                      "checkbox-config": {},
                    },
                    on: { "sort-change": _vm.sortChangeHandle },
                  },
                  [
                    _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
                    _c("vxe-column", {
                      attrs: { type: "checkbox", width: "40px" },
                    }),
                    _c("vxe-column", {
                      attrs: { field: "name", sortable: "", title: "品牌" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.hasPermission("test:treetable:car:edit")
                                ? _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        type: "primary",
                                        underline: false,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.name))]
                                  )
                                : _vm.hasPermission("test:treetable:car:view")
                                ? _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        type: "primary",
                                        underline: false,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.view(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.name))]
                                  )
                                : _c("span", [_vm._v(_vm._s(scope.row.name))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("vxe-column", {
                      attrs: {
                        field: "kind.name",
                        sortable: "",
                        title: "车系",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.kind && scope.row.kind.name
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("vxe-column", {
                      attrs: { field: "remarks", sortable: "", title: "简介" },
                    }),
                    _c("vxe-column", {
                      attrs: {
                        fixed: "right",
                        align: "center",
                        width: "200",
                        title: "操作",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.hasPermission("test:treetable:car:view")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-view",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.view(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("查看")]
                                  )
                                : _vm._e(),
                              _vm.hasPermission("test:treetable:car:edit")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-edit",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("修改")]
                                  )
                                : _vm._e(),
                              _vm.hasPermission("test:treetable:car:del")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-delete",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.del(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c("vxe-pager", {
                  attrs: {
                    background: "",
                    size: "small",
                    "current-page": _vm.tablePage.currentPage,
                    "page-size": _vm.tablePage.pageSize,
                    total: _vm.tablePage.total,
                    "page-sizes": [
                      10,
                      20,
                      100,
                      1000,
                      { label: "全量数据", value: 1000000 },
                    ],
                    layouts: [
                      "PrevPage",
                      "JumpNumber",
                      "NextPage",
                      "FullJump",
                      "Sizes",
                      "Total",
                    ],
                  },
                  on: { "page-change": _vm.currentChangeHandle },
                }),
              ],
              1
            ),
            _c("CarForm", {
              ref: "carForm",
              on: { refreshDataList: _vm.refreshList },
            }),
            _c("CarKindForm", {
              ref: "carKindForm",
              on: { refreshTree: _vm.refreshTree },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }